import { render, staticRenderFns } from "./miniGameRewardOp.vue?vue&type=template&id=0930a930&lang=pug"
import script from "./miniGameRewardOp.vue?vue&type=script&lang=js"
export * from "./miniGameRewardOp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports